<template>
  <div
    v-if="hasTrialed && !hasAccess && route.name !== 'my-account'"
    class="bg-black dark:bg-white text-neutral-50 dark:text-neutral-950 py-3"
  >
    <ContainerBasic
      class="flex flex-col gap-2 lg:flex-row items-center justify-center"
    >
      <p><strong>Your trial has ended.</strong> Get back in the game!</p>
      <UButton
        :to="{ path: '/my-account' }"
        class="ml-5"
        label="Activate Subscription"
        color="white"
      />
    </ContainerBasic>
  </div>
  <div
    v-if="hasPortalPass && !hasCurrentPortalPass && route.name !== 'my-account'"
    class="py-3"
    :class="{
      'bg-cardinal-700 text-white': hasExpiredPortalPass,
      'bg-gold text-neutral-950': !hasExpiredPortalPass,
    }"
  >
    <ContainerBasic
      class="flex flex-col gap-2 lg:flex-row items-center justify-center"
    >
      <i
        class="far text-2xl"
        :class="{
          'fa-info-circle': hasExpiredPortalPass,
          'fa-exclamation-triangle': !hasExpiredPortalPass,
        }"
      ></i>
      <p>
        <strong>{{ renewPortalPassTitle }}</strong>
      </p>
      <UButton
        :to="{ path: '/my-account' }"
        class="ml-5"
        label="Renew Your Portal Pass"
        color="white"
      />
    </ContainerBasic>
  </div>
</template>

<script lang="ts" setup>
const route = useRoute();
const profileStore = useProfileStore();
const { profile, setProfile } = profileStore;
const {
  hasAccess,
  hasPortalPass,
  hasCurrentPortalPass,
  hasTrialed,
  hasExpiredPortalPass,
} = storeToRefs(profileStore);

const props = defineProps<{
  renewTitle?: string;
}>();

const renewPortalPassTitle = computed(() => {
  const defaultTitle = hasExpiredPortalPass.value
    ? 'Attention: Your Portal Pass has expired. We are offering a discount for multi-year renewals.'
    : 'Attention: Your Portal Pass will expire when the 2025 season starts on February 1, 2025';
  return props.renewTitle || defaultTitle;
});
</script>
